import React from "react";
import Typography from "@material-ui/core/Typography";

interface IFallbackComponentProps {
  componentStack: string,
  error: Error
}

export type ErrorBoundaryElement = React.FC<IFallbackComponentProps>;

function toTitle(error: Error | null, componentStack: string | null) {
  if ( error && componentStack ) {
    return `${error.toString()}\n\nThis is located at:${componentStack}`;
  } else {
    return "";
  }
}

const FallbackComponent = ({ componentStack, error }: IFallbackComponentProps) => (
  <Typography title={toTitle(error, componentStack)}>
    Hiba történt a komponens betöltése közben.
  </Typography>
);

export default FallbackComponent;
